module.exports = __webpack_public_path__ + "img/checkmark.398fc16c.svg";